import { render, staticRenderFns } from "./Figures.vue?vue&type=template&id=42d8d0bc&scoped=true&"
import script from "./Figures.vue?vue&type=script&lang=js&"
export * from "./Figures.vue?vue&type=script&lang=js&"
import style0 from "./Figures.vue?vue&type=style&index=0&id=42d8d0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8d0bc",
  null
  
)

export default component.exports